import { render, staticRenderFns } from "./CalculusViz.vue?vue&type=template&id=a8f14340&scoped=true"
import script from "./CalculusViz.vue?vue&type=script&lang=js"
export * from "./CalculusViz.vue?vue&type=script&lang=js"
import style0 from "./CalculusViz.vue?vue&type=style&index=0&id=a8f14340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f14340",
  null
  
)

export default component.exports